import { useEffect, useRef, useState } from 'react';

// Плавное «набегание» числа от 0 (или от прошлого значения) до целевого, 700 мс. Без анимации при prefers-reduced-motion
// и в упрощённом виде (data-lite). Нечисловые значения (прочерк, строки) возвращаются как есть.
export default function useCountUp(value, duration = 700) {
  const target = typeof value === 'number' && Number.isFinite(value) ? value : null;
  const [shown, setShown] = useState(target);
  const from = useRef(0);
  useEffect(() => {
    if (target === null) { setShown(value); return undefined; }
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || document.documentElement.getAttribute('data-lite') === 'true') { setShown(target); from.current = target; return undefined; }
    const start = from.current; const t0 = performance.now(); let raf = 0;
    const step = (now) => {
      const p = Math.min(1, (now - t0) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      setShown(Math.round(start + (target - start) * eased));
      if (p < 1) raf = requestAnimationFrame(step); else from.current = target;
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [target, value, duration]);
  return shown;
}
